(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tauruss-compra-extra"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tq-compra-extra')) {
    customElements.define(
      'tq-compra-extra',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.placed) return;
          const trust = document.querySelector('.tqP__info .tqP__trust');
          if (!trust) return;
          this.dataset.placed = 'true';
          const invima = this.querySelector('[data-tq-trust]');
          if (invima) {
            invima.classList.add('tqP__trust-item');
            trust.appendChild(invima);
          }
          trust.insertAdjacentElement('afterend', this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
